/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BookbindingspinetypesQueryResponse } from '../../types/GetV1Bookbindingspinetypes.ts'

export const getV1BookbindingspinetypesQueryKey = () =>
    [{ url: '/v1/BookBindingSpineTypes' }] as const

export type GetV1BookbindingspinetypesQueryKey = ReturnType<
    typeof getV1BookbindingspinetypesQueryKey
>

/**
 * {@link /v1/BookBindingSpineTypes}
 */
export async function getV1Bookbindingspinetypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1BookbindingspinetypesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/BookBindingSpineTypes`, ...requestConfig })
    return res
}

export function getV1BookbindingspinetypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BookbindingspinetypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BookbindingspinetypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BookbindingspinetypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Bookbindingspinetypes(config)
        },
    })
}

/**
 * {@link /v1/BookBindingSpineTypes}
 */
export function useGetV1Bookbindingspinetypes<
    TData = ResponseConfig<GetV1BookbindingspinetypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1BookbindingspinetypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1BookbindingspinetypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BookbindingspinetypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BookbindingspinetypesQueryKey()

    const query = useQuery(
        {
            ...getV1BookbindingspinetypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
